module.exports = __webpack_public_path__ + "assets/img/36_568_big.f0cad1a9.jpg";